<template>
  <div class="app-container">
    <!-- 面包屑 - 响应式调整 -->
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="breadcrumb-item">用户管理</el-breadcrumb-item>
        <el-breadcrumb-item class="breadcrumb-item">用户栏目权限管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-divider></el-divider>

    <!-- 搜索表单 - 响应式切换 inline 模式 -->
    <el-form
        :model="queryParams"
        ref="queryForm"
        size="small"
        :inline="isInline"
        v-show="showSearch"
        class="search-form"
    >
      <el-form-item label="员工号" prop="userName" class="form-item">
        <el-input
            v-model="queryParams.userName"
            placeholder="请输入员工号"
            clearable
            :style="{width: formItemWidth}"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item class="form-item">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 工具栏 - 响应式栅格 -->
    <el-row :gutter="10" class="mb8">
      <el-col
          :xs="6"
          :sm="3"
          :md="1.5"
          class="toolbar-col"
      >
        <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            class="operation-btn"
            @click="handleAdd"
        >新增</el-button>
      </el-col>
    </el-row>

    <!-- 用户表格 - 移动端横向滚动 -->
    <div class="table-container">
      <avue-crud
          ref="userClassifyCrud"
          :option="option"
          :data="tableData"
          :cell-style="tableCellStyle"
          :header-cell-style="tableHeaderStyle"
      >
        <template slot-scope="{row,index}" slot="menu">
          <el-button
              size="mini"
              type="success"
              icon="el-icon-edit"
              class="table-btn edit-btn"
              @click="handleUpdate(row,index)"
          >修改</el-button>
          <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              class="table-btn delete-btn"
              @click="handleDelete(row,index)"
          >删除</el-button>
        </template>
      </avue-crud>
    </div>

    <!-- 对话框 - 响应式宽度 -->
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        :width="dialogWidth"
        append-to-body
        @close="cancel"
        class="custom-dialog"
    >
      <el-form
          ref="form"
          :model="form"
          :rules="rules"
          :label-width="formLabelWidth"
          class="dialog-form"
      >
        <el-form-item label="员工号" prop="userName" class="dialog-form-item">
          <el-input
              v-model="form.userName"
              :readonly="isEditMode"
              placeholder="请输入员工号"
              @blur="fetchUserInfoByUserName"
              class="dialog-input"
          />
        </el-form-item>
        <el-form-item label="员工名" prop="nickName" class="dialog-form-item">
          <el-input
              v-model="form.nickName"
              readonly
              placeholder="请输入员工名"
              class="dialog-input"
          />
        </el-form-item>
        <el-form-item label="特殊权限" class="dialog-form-item">
          <el-switch v-model="form.permissionFlag" class="switch-component"></el-switch>
        </el-form-item>
        <el-form-item label="栏目权限" class="dialog-form-item">
          <div class="tree-controls">
            <el-checkbox v-model="classifyExpand" @change="handleCheckedTreeExpand($event, 'classify')">展开/折叠</el-checkbox>
            <el-checkbox v-model="classifyNodeAll" @change="handleCheckedTreeNodeAll($event, 'classify')">全选/全不选</el-checkbox>
            <el-checkbox v-model="form.classifyCheckStrictly" @change="handleCheckedTreeConnect($event, 'classify')">父子联动</el-checkbox>
          </div>
          <!-- 树组件 - 移动端滚动优化 -->
          <el-tree
              class="tree-border"
              :data="classifyOptions"
              show-checkbox
              ref="classify"
              node-key="id"
              :check-strictly="!form.classifyCheckStrictly"
              empty-text="加载中，请稍候"
              :props="defaultProps"
          ></el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="dialog-btn confirm-btn" @click="submitForm">确 定</el-button>
        <el-button class="dialog-btn cancel-btn" @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  queryUserInfo,
  addUserClassify,
  selectClassify,
  updateUserClassify,
  deleteUserClassify,
  selectClassifyByUserName, queryUserInfoInput
} from "@/api/userClassify/userClassify";
import { debounce } from 'lodash';
import {getLocal} from "@/utils/localstorage";

export default {
  name: "UserClassify",
  data() {
    return {
      adminName: undefined,
      fetchUserInfoDebounced: null,
      loading: false,
      ids: [],
      single: true,
      multiple: true,
      showSearch: true,
      allUserList: [],
      tableData: [],
      title: "",
      dialogVisible: false,
      classifyExpand: false,
      classifyNodeAll: false,
      isEditMode: false,
      classifyOptions: [],
      queryParams: {
        userName: undefined,
      },
      form: {
        userName: undefined,
        nickName: undefined,
        classifyIds: [],
        classifyCheckStrictly: true,
        permissionFlag: false
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      rules: {
        userName: [
          { required: true, message: "员工号不能为空", trigger: "blur" }
        ],
        nickName: [
          {
            validator: (rule, value, callback) => {
              const employeeId = (this.form.userName || '').trim();
              if (employeeId && !(value || '').trim()) {
                callback(new Error('未找到该员工的姓名，请检查员工号'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ]
      },
      // 表格配置 - 移动端适配
      option: {
        border: true,
        headerAlign: 'center',
        align: 'center',
        editBtn: false,
        delBtn: false,
        addBtn: false,
        labelWidth: 100,
        menuWidth: 180, // 移动端操作列宽度优化
        stripe: true,
        hoverable: true,
        fit: true,
        highlightCurrentRow: true,
        column: [
          {
            label: "员工号",
            prop: "userName",
            cellStyle: { 'background-color': '#f5f7fa' }
          },
          {
            label: "员工姓名",
            prop: "nickName",
            overHidden: true,
            cellStyle: { 'background-color': '#f5f7fa' }
          }
        ]
      },
      // 屏幕宽度（用于响应式）
      screenWidth: window.innerWidth
    };
  },
  computed: {
    // 判断是否为移动端（屏幕宽度 < 768px）
    isMobile() {
      return this.screenWidth < 768;
    },
    // 表单是否横向排列
    isInline() {
      return !this.isMobile; // 移动端垂直排列
    },
    // 表单项宽度
    formItemWidth() {
      return this.isMobile ? '100%' : '240px';
    },
    // 对话框宽度
    dialogWidth() {
      return this.isMobile ? '90%' : '500px';
    },
    // 表单标签宽度
    formLabelWidth() {
      return this.isMobile ? '80px' : '100px';
    },

  },
  created() {
    this.initTableData();
    this.fetchUserInfoDebounced = null;
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    // 处理窗口大小变化
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    // 表格单元格样式
    tableCellStyle({ row, column, rowIndex, columnIndex }) {
      return {
        padding: this.isMobile ? '6px 8px' : '8px 10px',
        fontSize: this.isMobile ? '12px' : '14px'
      };
    },
    tableHeaderStyle({ row, column, rowIndex, columnIndex }) {
      return {
        padding: this.isMobile ? '8px 8px' : '10px 10px',
        fontSize: this.isMobile ? '13px' : '14px'
      };
    },
    initTableData() {
      this.loading = false;
      const successInfo = JSON.parse(getLocal("successInfo"));
      this.adminName = successInfo.workNo;
      this.getClassifyTreeselect(successInfo.workNo);
    },
    fetchUserInfoByUserName() {
      const userName = this.form.userName?.trim();
      if (this.isEditMode){
        this.loading = false;
        return;
      }
      if (!userName) {
        this.form.nickName = '';
        this.loading = false;
        return;
      }
      if (!this.fetchUserInfoDebounced) {
        this.fetchUserInfoDebounced = debounce(() => {
          this.loading = true;
          this.actualFetchUserInfo();
        }, 200);
      }
      this.fetchUserInfoDebounced();
    },
    actualFetchUserInfo() {
      const userName = this.form.userName?.trim();
      if (!userName) return;
      queryUserInfoInput(userName)
          .then(response => {
            if (response.code === 200 && response.data) {
              const data = response.data || {};
              this.form.nickName = data.nickName || '';
              if (!this.form.nickName) {
                this.$message.warning(`员工号 ${userName} 未找到对应姓名`);
              }
            } else {
              this.$message.warning(response.message || '查询员工信息失败');
              this.form.nickName = '';
            }
          })
          .catch(error => {
            console.error('获取员工信息失败:', error);
            this.$message.error('获取员工信息失败，请重试');
            this.form.nickName = '';
          })
          .finally(() => {
            this.loading = false;
          });
    },

    handleAdd() {
      this.reset();
      this.getClassifyTreeselect(this.adminName);
      this.dialogVisible = true;
      this.title = "新增用户栏目权限";
      this.isEditMode = false;
      this.form.nickName = '';
    },
    handleUpdate(row, index) {
      if (!row && this.$refs.userClassifyCrud.selection.length) {
        row = this.$refs.userClassifyCrud.selection[0];
      }
      if (!row) {
        return this.$message.warning("请选择需要修改的数据");
      }
      try {
        this.reset();
        this.form = JSON.parse(JSON.stringify(row));
        this.loading = true;
        this.getUserClassifyTree(row.userName,{
          withLoading: true,
          needFormat: true
        })
            .then(response => {
              if (!response.success) {
                throw new Error(response.message);
              }
              this.dialogVisible = true;
              this.title = "修改用户栏目权限";
              this.isEditMode = true;
              return this.$nextTick(() => {
                if (!this.$refs.classify) {
                  throw new Error("树组件未正确挂载");
                }
                this.$refs.classify.setCheckedKeys([]);
                response.checkedKeys.forEach(checkedId => {
                  this.$refs.classify.setChecked(checkedId, true, false);
                });
              });
            })
            .catch(error => {
              console.error("编辑操作异常:", error);
              this.$message.error(error.message || "获取用户栏目权限失败，请重试");
              this.dialogVisible = false;
            })
            .finally(() => {
              this.loading = false;
            });
      } catch (error) {
        console.error("编辑操作异常:", error);
        this.$message.error("编辑操作异常，请重试");
        this.dialogVisible = false;
      }
    },
    getClassifyTreeselect(data) {
      selectClassify(data).then(response => {
        if (200 == response.code){
          this.classifyOptions = this.transformCategoryData(response.data);
        } else {
          console.log("获取栏目为空")
        }
      }).catch(error => {
        console.error("获取栏目树失败:", error);
      });
    },
    transformCategoryData(data) {
      return data.map(item => {
        const children = item.children && item.children.length > 0
            ? item.children.map(child => ({
              id: child.id,
              label: child.title
            }))
            : [];
        return {
          id: item.id,
          label: item.title,
          children: children
        };
      });
    },
    getUserClassifyTree(userName, options = {}) {
      const defaultOptions = {
        withLoading: true,
        needFormat: true
      };
      const { withLoading, needFormat } = { ...defaultOptions, ...options };
      if (withLoading) {
        this.loading = true;
      }
      return new Promise((resolve, reject) => {
        selectClassifyByUserName(userName)
            .then(rawResponse => {
              if (!rawResponse) {
                throw new Error('接口返回数据为空');
              }
              const formattedResponse = needFormat
                  ? {
                    code: rawResponse.code || 500,
                    message: rawResponse.message || '未知错误',
                    checkedKeys: rawResponse.data || [],
                    success: rawResponse.code === 200
                  }
                  : rawResponse;
              if (formattedResponse.success && !Array.isArray(formattedResponse.checkedKeys)) {
                throw new Error('栏目权限数据格式异常，checkedKeys应为数组');
              }
              resolve(formattedResponse);
            })
            .catch(error => {
              let errorMsg = '请求失败';
              if (error.response) {
                errorMsg = `接口错误 [${error.response.status}]: ${error.response.statusText}`;
              } else if (error.request) {
                errorMsg = '网络请求已发送，但未收到响应';
              } else {
                errorMsg = error.message || errorMsg;
              }
              reject(new Error(errorMsg));
            })
            .finally(() => {
              if (withLoading) {
                this.loading = false;
              }
            });
      });
    },
    handleDelete(row, index) {
      this.$confirm(`是否确认删除用户名为"${row.nickName}"的数据项？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        deleteUserClassify(row.userName)
            .then(response => {
              if (response.code === 200) {
                this.$message.success("删除成功");
                const userData = {
                  id: row.userName,
                  userName: row.userName,
                  nickName: row.nickName,
                  permissionFlag: row.permissionFlag
                };
                const index = this.allUserList.findIndex(item => item.id === row.id);
                if (index !== -1) {
                  this.allUserList.splice(index, 1);
                  this.tableData = [...this.allUserList];
                }
              } else {
                this.$message.error("删除失败,"+response.message);
              }
            })
            .catch(error => {
              console.error("删除操作失败:", error);
              this.$message.error(error.message || "删除失败，请重试");
            })
            .finally(() => {
              this.loading = false;
            });
      }).catch(() => {
        this.$message.info("已取消删除");
      });
    },
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.getClassifyAllCheckedKeys().then(checkedKeys => {
            const formData = JSON.parse(JSON.stringify(this.form));
            formData.classifyIds = checkedKeys;
            if (formData.id) {
              updateUserClassify(formData).then(response => {
                if (200 == response.code) {
                  this.$message.success("修改成功");
                  const userData = {
                    id: formData.userName,
                    userName: formData.userName,
                    nickName: formData.nickName,
                    permissionFlag: formData.permissionFlag
                  };
                  const index = this.allUserList.findIndex(item => item.id === formData.id);
                  if (index !== -1) {
                    this.allUserList[index] = userData;
                    this.tableData = [...this.allUserList];
                  }
                } else {
                  this.$message.error("修改失败,"+response.message);
                }
                this.dialogVisible = false;
              });
            } else {
              addUserClassify(formData).then(response => {
                if (200 === response.code){
                  const userData = {
                    id: formData.userName,
                    userName: formData.userName,
                    nickName: formData.nickName,
                    permissionFlag: formData.permissionFlag
                  };
                  this.allUserList = [];
                  this.allUserList.push(userData);
                  this.tableData = [...this.allUserList];
                  this.$message.success("新增成功");
                  this.dialogVisible = false;
                } else {
                  this.$message.error("新增失败"+response.message);
                }
              });
            }
          });
        }
      });
    },
    getClassifyAllCheckedKeys() {
      return new Promise(resolve => {
        if (!this.$refs.classify) {
          resolve([]);
          return;
        }
        this.$nextTick(() => {
          const checkedKeys = this.$refs.classify.getCheckedKeys();
          const halfCheckedKeys = this.$refs.classify.getHalfCheckedKeys();
          resolve([...halfCheckedKeys, ...checkedKeys]);
        });
      });
    },
    cancel() {
      this.dialogVisible = false;
      this.reset();
    },
    reset() {
      this.form = {
        userName: undefined,
        nickName: undefined,
        classifyIds: [],
        classifyCheckStrictly: true,
        permissionFlag: false
      };
      this.classifyExpand = false;
      this.classifyNodeAll = false;
      this.isEditMode = false;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      if (this.dialogVisible) {
        this.$nextTick(() => {
          if (this.$refs.classify) {
            this.$refs.classify.setCheckedKeys([]);
          }
        });
      }
    },
    handleQuery() {
      this.getList();
      this.resetForm("queryForm");
    },
    resetQuery() {
      this.resetForm("queryForm");
    },
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
    },
    handleCheckedTreeExpand(value, type) {
      if (type === 'classify' && this.$refs.classify) {
        this.$nextTick(() => {
          const treeList = this.classifyOptions;
          for (let i = 0; i < treeList.length; i++) {
            const node = this.$refs.classify.store.nodesMap[treeList[i].id];
            if (node) {
              node.expanded = value;
            }
          }
        });
      }
    },
    handleCheckedTreeNodeAll(value, type) {
      if (type === 'classify' && this.$refs.classify) {
        this.$nextTick(() => {
          this.$refs.classify.setCheckedNodes(value ? this.classifyOptions : []);
        });
      }
    },
    handleCheckedTreeConnect(value, type) {
      if (type == 'classify') {
        this.form.classifyCheckStrictly = value;
      }
    },
    getList() {
      this.loading = true;
      this.$nextTick(() => {
        this.$refs.userClassifyCrud.$el.appendChild(this.createLoadingMask());
      });
      queryUserInfo(this.queryParams).then(response => {
        this.loading = false;
        if (response.code === 200) {
          const result = response.data || {};
          this.allUserList = [];
          this.allUserList.push(result);
          this.tableData = this.allUserList ? this.allUserList : [];
        } else {
          this.$message.error(response.message || "获取数据失败");
          this.tableData = [];
          this.allUserList = [];
        }
        this.removeLoadingMask();
      }).catch(error => {
        console.error("获取数据失败:", error);
        this.loading = false;
        this.$message.error("获取数据失败，请重试");
        this.tableData = [];
        this.allUserList = [];
        this.removeLoadingMask();
      });
    },
    createLoadingMask() {
      const mask = document.createElement('div');
      mask.className = 'loading-mask';
      mask.style.position = 'absolute';
      mask.style.top = '0';
      mask.style.left = '0';
      mask.style.width = '100%';
      mask.style.height = '100%';
      mask.style.background = 'rgba(255,255,255,0.8)';
      mask.style.zIndex = '1000';
      mask.style.display = 'flex';
      mask.style.justifyContent = 'center';
      mask.style.alignItems = 'center';
      const spinner = document.createElement('div');
      spinner.className = 'el-loading-spinner';
      spinner.style.width = '30px';
      spinner.style.height = '30px';
      spinner.style.border = '2px solid #ccc';
      spinner.style.borderTopColor = '#409EFF';
      spinner.style.borderRadius = '50%';
      spinner.style.animation = 'loading-rotate 1s linear infinite';
      mask.appendChild(spinner);
      return mask;
    },
    removeLoadingMask() {
      const mask = document.querySelector('.loading-mask');
      if (mask) {
        mask.remove();
      }
    },
  },
  beforeDestroy() {
    if (this.fetchUserInfoDebounced) {
      this.fetchUserInfoDebounced.cancel();
      this.fetchUserInfoDebounced = null;
    }
    this.loading = false;
    // 移除窗口监听
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
/* 全局容器样式 */
.app-container {
  padding: 24px;
  background-color: #f8fafc;
}
@media (max-width: 768px) {
  .app-container {
    padding: 10px;
  }
}

/* 面包屑样式 */
.breadcrumb {
  margin-bottom: 16px;
}
.breadcrumb-item {
  font-size: 14px;
}
@media (max-width: 768px) {
  .breadcrumb {
    margin-bottom: 10px;
  }
  .breadcrumb-item {
    font-size: 12px;
  }
}

/* 搜索表单样式 */
.search-form {
  margin-bottom: 16px;
}
.form-item {
  margin-bottom: 10px;
}
@media (max-width: 768px) {
  .search-form {
    margin-bottom: 10px;
  }
  .form-item {
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 8px;
  }
}

/* 工具栏样式 */
.toolbar-col {
  margin-bottom: 0;
}
.operation-btn {
  min-width: 48px;
  min-height: 32px;
}
@media (max-width: 768px) {
  .toolbar-col {
    margin-bottom: 8px;
  }
  .operation-btn {
    min-width: 56px;
    min-height: 36px;
    font-size: 13px;
  }
}

/* 表格容器 - 横向滚动 */
.table-container {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 15px;
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* 表格按钮样式 */
.table-btn {
  margin-right: 4px;
  min-width: 40px;
  padding: 4px 8px;
}
.edit-btn {
  margin-right: 6px;
}
@media (max-width: 768px) {
  .table-btn {
    min-width: 44px;
    padding: 6px 8px;
    font-size: 12px;
  }
}

/* 对话框样式 */
.custom-dialog .dialog-form {
  padding: 10px 0;
}
.custom-dialog .dialog-form-item {
  margin-bottom: 16px;
}
.custom-dialog .dialog-input {
  width: 100%;
}
.custom-dialog .tree-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}
.custom-dialog .tree-border {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 10px;
  margin-top: 5px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  max-height: 300px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.custom-dialog .dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 10px 0;
}
.custom-dialog .dialog-btn {
  min-width: 80px;
  min-height: 36px;
}

/* 移动端对话框适配 */
@media (max-width: 768px) {
  .custom-dialog .dialog-form-item {
    margin-bottom: 12px;
  }
  .custom-dialog .dialog-input {
    min-height: 36px;
  }
  .custom-dialog .tree-controls {
    gap: 6px;
    font-size: 12px;
  }
  .custom-dialog .tree-border {
    max-height: 240px;
    padding: 8px;
    font-size: 12px;
  }
  .custom-dialog .dialog-btn {
    min-width: 70px;
    min-height: 34px;
    font-size: 13px;
    padding: 6px 12px;
  }
}

/* 开关组件 */
.switch-component {
  margin-top: 4px;
}

/* 加载遮罩动画 */
@keyframes loading-rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 响应式表格优化 */
@media (max-width: 768px) {
  .el-table {
    font-size: 12px;
  }
  .el-table th,
  .el-table td {
    padding: 6px 8px;
  }
  .el-table--border th,
  .el-table--border td {
    border-right: 1px solid #ebeef5;
  }
  .el-table--border th:last-child,
  .el-table--border td:last-child {
    border-right: none;
  }
}

/* 按钮交互反馈 */
.el-button {
  border-radius: 4px;
  transition: all 0.2s;
}
.el-button:active {
  transform: translateY(0);
}
.el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(64, 158, 255, 0.3);
}
@media (max-width: 768px) {
  .el-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
  }
}

/* 提示消息适配 */
.el-message {
  min-width: 280px !important;
}
@media (max-width: 768px) {
  .el-message {
    min-width: 240px !important;
    font-size: 12px !important;
    padding: 10px 16px !important;
  }
}
</style>
